

(function ($) {
    'use strict';

    $(document).ready(function () {
        const toggler = document.getElementById('nav-toggler');
        const navbar = document.getElementById('navbar');

        // Listen for Bootstrap collapse events to toggle 'collapsed' class
        navbar.addEventListener('shown.bs.collapse', function () {
            toggler.classList.remove('collapsed');
        });

        navbar.addEventListener('hidden.bs.collapse', function () {
            navbar.classList.add('collapsing-custom');
            setTimeout(function () {
                toggler.classList.add('collapsed');
                navbar.classList.remove('show', 'collapsing-custom');
            }, 300); // Match the CSS transition duration
        });

        // Modify href and add data-bs-toggle for dropdowns under 992px
        $('.responsive-dropdown').each(function () {
            let originalHref = $(this).attr('href');

            if ($(window).width() < 992) {
                $(this).attr('href', '#');
                $(this).attr('data-bs-toggle', 'dropdown');
            } else {
                if ($(this).attr('data-href')) {
                    $(this).attr('href', $(this).attr('data-href'));
                    $(this).removeAttr('data-bs-toggle');
                }
            }
        });

        // Add toggle icons to dropdowns
        $('.dropdown-toggle').each(function () {
            if (!$(this).find('.dropdown-toggle-icon').length) {
                $(this).append('<span class="dropdown-toggle-icon">+</span>');
            }
        });

        // Update icon when dropdown is shown
        $('.dropdown-toggle').on('shown.bs.dropdown', function () {
            $(this).find('.dropdown-toggle-icon').text('-');
        });

        // Update icon when dropdown is hidden
        $('.dropdown-toggle').on('hidden.bs.dropdown', function () {
            $(this).find('.dropdown-toggle-icon').text('+');
        });
    });
})(jQuery);
